import { createAction } from '@reduxjs/toolkit';

export const clearContent = createAction('content/CLEAR_CONTENT');
export const fetchContent = createAction('content/FETCH_CONTENT');
export const setContent = createAction('content/SET_CONTENT');
